import { SVGProps } from "react";

export const BaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111 111" {...props}>
    <circle cx="55.5" cy="55.5" r="55.5" fill="#0052FF" />
    <path
      fill="#FFFFFF"
      d="M55.4 94.2c21.4 0 38.8-17.3 38.8-38.7 0-21.4-17.4-38.7-38.8-38.7-20.2 0-36.8 15.4-38.6 35.1h51.3v7.2H16.8c1.8 19.7 18.4 35.1 38.6 35.1z"
    />
  </svg>
);
